import { Component, OnDestroy, OnInit } from '@angular/core';
import { filterUndefined } from 'src/app/lego-utils';
import { combineLatest, Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { DesignService, NotificationService, PMOrderService } from 'src/app/state';
import { EquipmentLookupService } from 'src/app/state/equipment/equipment-lookup.service';

@Component({
  selector: 'em-element-status',
  styleUrls: ['./element-status.component.less'],
  templateUrl: './element-status.component.html',
  standalone: false,
})
export class ElementStatusComponent implements OnInit, OnDestroy {
  public designLoading$ = this.designService.loading$;
  public notification$ = this.notificationService.newestZE$;
  public notificationIsLoading$ = this.notificationService.loading$;
  public notificationError$ = this.notificationService.error$;

  public primaryOrder$ = this.pmOrderService.primaryOrder$;
  public orderIsLoading$ = this.pmOrderService.loading$;
  public orderError$ = this.pmOrderService.error$;

  public loading$ = combineLatest([
    this.designLoading$,
    this.notificationIsLoading$,
    this.orderIsLoading$,
  ]).pipe(
    map(
      ([designLoading, notificationIsLoading, orderIsLoading]) =>
        designLoading || notificationIsLoading || orderIsLoading
    )
  );

  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly designService: DesignService,
    private readonly equipmentLookup: EquipmentLookupService,
    private readonly notificationService: NotificationService,
    private readonly pmOrderService: PMOrderService
  ) {}

  public ngOnInit() {
    this.subscriptions.add(
      this.equipmentLookup.selectedEquipmentId$
        .pipe(
          filterUndefined(() => {
            this.notificationService.reset();
          }),
          switchMap((equipmentNumber) =>
            this.notificationService.loadByEquipmentNumber(equipmentNumber)
          )
        )
        .subscribe()
    );

    this.subscriptions.add(this.pmOrderService.loadByActiveEquipment().subscribe());
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
